export default __webpack_public_path__ + "static/media/left-bottom.9ce23676.gif";